import React from "react";
import TipStuList from "../TipStuList";
import style from "./index.module.scss";
import { EndExerciseStuInfo } from "service/exercise";

interface RightWrongCountProps {
    rightList: EndExerciseStuInfo[];
    wrongList: EndExerciseStuInfo[];
}

export default function RightWrongCount({
    rightList,
    wrongList
}: RightWrongCountProps) {
    return (
        <div className={style.root}>
            <TipStuList stuList={rightList}>
                <span>作答正确 {rightList.length}</span>
            </TipStuList>

            <TipStuList stuList={wrongList}>
                <span>作答错误 {wrongList.length}</span>
            </TipStuList>
        </div>
    );
}
